import { describeArc } from '../../util/calculationUtils';
import classes from './ProgressDonut.module.scss';

const ProgressDonut = (props: { value: number; max: number }): JSX.Element => {
  const { value, max } = props;
  const arcLength = (value / max) * 360;

  return (
    <div className={classes.container}>
      <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle
          cx="50"
          cy="50"
          r="45"
          className={classes.circle}
          vectorEffect="non-scaling-stroke"
        />
        {arcLength < 360 ? (
          <path
            d={describeArc(50, 50, 45, 0, arcLength)}
            className={classes.arc}
            vectorEffect="non-scaling-stroke"
          />
        ) : (
          <circle
            cx="50"
            cy="50"
            r="45"
            className={classes.arc}
            vectorEffect="non-scaling-stroke"
          />
        )}
      </svg>
    </div>
  );
};

export default ProgressDonut;
